module.exports = __webpack_public_path__ + "img/logo-rubik.2ab40e49.png";